<template>
  <div class="bg" :style="{ height: totalHeight,width:'100%'}" style="background-image: url('../../static/img/bg_login_2.png');background-size: cover;">
    <img src="../assets/mq_blue_logo.png" style="width:231px;height:31px;margin-top:40px;margin-left: 130px;cursor: pointer;" @click="goToMain"/>
    <div class="login-layout">
      <div class="login-box">
        <component :is="register" v-on:RLChange="changeLoginRegister()" v-on:LRChange="changeRegisterLogin()" v-on:PLChange="changePasswordLogin()" v-on:VLChange="changeCAPTCHALogin()"></component>
      </div>
    </div>
  </div>
</template>

<script>
import AccountLogin from '../components/AccountLogin'
import Register from '../components/Register'
import ChangePassword from '../components/ChangePassword'
import CAPTCHALogin from '../components/CAPTCHALogin'
export default {
  name: 'Login',
  data () {
    return {
      phone: 0,
      register: AccountLogin,
    }
  },
  computed: {
    totalHeight () {
      return window.innerHeight + 'px'
    }
  },
  methods: {
    goToMain(){
      this.$router.back()
    },
    changeLoginRegister () {
      this.register = Register
    },
    changeRegisterLogin () {
      this.register = AccountLogin
    },
    changePasswordLogin () {
      this.register = ChangePassword
    },
    changeCAPTCHALogin () {
      this.register = CAPTCHALogin
    }
  }
}
</script>

<style scoped>
  .bg{
    background-color: #E3F5FF;
    display: flex;
    flex-direction: column;
  }
  .login-layout{
    margin-top: 34px;
    margin-left: 113px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .login-img{
    width: 900px;
    height: 804px;
  }
  .login-box{
    margin-left: 1059px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Login.vue